import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@src/environments/environment';
import { AppModule } from './app/app.module';

import { DtrumApi } from '@dynatrace/dtrum-api-types';

if (environment.production) {
    enableProdMode();
}

const mainLoadedTime = Date.now();
window['mainLoadedTime'] = mainLoadedTime;
if (!environment.production) {
  console.debug("Main loaded at ", mainLoadedTime);
}

window.dtrum?.setAutomaticActionDetection(false);
window.dtrum?.enableManualPageDetection();
window.dtrum?.setLoadEndManually();

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => {
        if (!environment.production) {
            console.error(err);
        }
    });
